let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("3689E"), load("g1XVY"), load("1a9Rr")]).then(() => parcelRequire('7fnEu'));